import { TPasskeyItem } from "@/api/services/main/auth/dtos/passkey.dto";
import { Modal } from "@/components/elements/Modal";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TDeletePasskeyModalProps = {
  target: TPasskeyItem | null;
  isDeleting: boolean;
  onOk: () => void;
  onClose: () => void;
};

export const DeletePasskeyModal: FC<TDeletePasskeyModalProps> = ({ target, isDeleting, onOk, onClose }) => {
  return (
    <Modal
      isOpen={!!target}
      title="パスキーの削除"
      labelOk="削除する"
      labelClose="キャンセル"
      isLoadingOkBtn={isDeleting}
      onOk={onOk}
      onClose={onClose}
    >
      <Stack gap="12px" py="8px" mb="16px" width={360}>
        <Typography variant="body14" color={text.secondary}>
          「{target?.deviceName || "パスキー"}」を削除します。このパスキーではログインできなくなります。よろしいですか？
        </Typography>
      </Stack>
    </Modal>
  );
};
